export default __webpack_public_path__ + "static/media/more-info.6a2214be.svg";